// extracted by mini-css-extract-plugin
var _1 = "SectionDivider-module__line___peBQr";
var _2 = "SectionDivider-module__text___RqYoS";
var _3 = "SectionDivider-module__wrapper___Oz7yY";
export { _1 as "line", _2 as "text", _3 as "wrapper" }
